_setUserLocalData